import React, { useState, useEffect } from "react";
import classnames from "classnames";
import HomeIcon from "../images/home-btn@2x.png";
import HomeIconHover from "../images/home-btn-hover@2x.png";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
    let location = useLocation();
    return (
        <footer className={classnames("absolute bottom-5 right-5")}>
            <p
                className={classnames("font-proxima-nova font-semibold text-[16px]")}
            >
                Copyright© 2023 Dell Inc. or its subsidiaries. All Rights Reserved.
            </p>
        </footer>
    );
};

export default Footer;
